__turbopack_context__.v({
  "badges": "RPB2Lq_badges",
  "details": "RPB2Lq_details",
  "face": "RPB2Lq_face",
  "faceHeader": "RPB2Lq_faceHeader",
  "facts": "RPB2Lq_facts",
  "image": "RPB2Lq_image",
  "oracle": "RPB2Lq_oracle",
  "text": "RPB2Lq_text",
  "typeLine": "RPB2Lq_typeLine",
});
